import React from 'react';
import {FormattedMessage} from 'react-intl';

import musicIconURL from './music/music.png';
import musicInsetIconURL from './music/music-small.svg';

import penIconURL from './pen/pen.png';
import penInsetIconURL from './pen/pen-small.svg';

import videoSensingIconURL from './videoSensing/video-sensing.png';
import videoSensingInsetIconURL from './videoSensing/video-sensing-small.svg';

import text2speechIconURL from './text2speech/text2speech.png';
import text2speechInsetIconURL from './text2speech/text2speech-small.svg';

import nlpIconURL from './nlp/nlp.png';
import nlpInsetIconURL from './nlp/nlp-small.svg';

import translateIconURL from './translate/translate.png';
import translateInsetIconURL from './translate/translate-small.png';

import makeymakeyIconURL from './makeymakey/makeymakey.png';
import makeymakeyInsetIconURL from './makeymakey/makeymakey-small.svg';

import genericDeviceIconURL from './genericDevice/generic-banner.png';
import genericDeviceInsetIconURL from './genericDevice/generic-small.svg';

import microbitIconURL from './microbit/microbit.png';
import microbitInsetIconURL from './microbit/microbit-small.svg';
import microbitConnectionIconURL from './microbit/microbit-illustration.svg';
import microbitConnectionSmallIconURL from './microbit/microbit-small.svg';

import max30105IconURL from './max30105/max30105_banner.png';
import max30105InsetIconURL from './max30105/max30105_small.png';

import ev3IconURL from './ev3/ev3.png';
import ev3InsetIconURL from './ev3/ev3-small.svg';
import ev3ConnectionIconURL from './ev3/ev3-hub-illustration.svg';
import ev3ConnectionSmallIconURL from './ev3/ev3-small.svg';

import wedo2IconURL from './wedo2/wedo.png'; // TODO: Rename file names to match variable/prop names?
import wedo2InsetIconURL from './wedo2/wedo-small.svg';
import wedo2ConnectionIconURL from './wedo2/wedo-illustration.svg';
import wedo2ConnectionSmallIconURL from './wedo2/wedo-small.svg';
import wedo2ConnectionTipIconURL from './wedo2/wedo-button-illustration.svg';

import boostIconURL from './boost/boost.png';
import boostInsetIconURL from './boost/boost-small.svg';
import boostConnectionIconURL from './boost/boost-illustration.svg';
import boostConnectionSmallIconURL from './boost/boost-small.svg';
import boostConnectionTipIconURL from './boost/boost-button-illustration.svg';

import gdxforIconURL from './gdxfor/gdxfor.png';
import gdxforInsetIconURL from './gdxfor/gdxfor-small.svg';
import gdxforConnectionIconURL from './gdxfor/gdxfor-illustration.svg';
import gdxforConnectionSmallIconURL from './gdxfor/gdxfor-small.svg';

import irSensorIconURL from './irSensor/ir-sensor-banner.png';
import irSensorInsetIconURL from './irSensor/ir-sensor-small.png';

import ultrasonicSensorIconURL from './ultrasonicSensor/ultrasonic-banner.png';
import ultrasonicSensorInsetIconURL from './ultrasonicSensor/ultrasonic-small.png';

import servoMotorIconURL from './servoMotor/servo-banner.png';
import servoMotorInsetIconURL from './servoMotor/servo-small.png';

import dcMotorIconURL from './dcMotor/dc-motor-banner.png';
import dcMotorInsetIconURL from './dcMotor/dc-motor-small.png';

import oledDisplayIconURL from './oledDisplay/generic-banner.png';
import oledDisplayInsetIconURL from './oledDisplay/generic-small.svg';

import ledActuatorIconURL from './ledActuator/led-banner.png';
import ledActuatorInsetIconURL from './ledActuator/led-small.png';

import pirSensorIconURL from './pirSensor/pir-banner.png';
import pirSensorInsetIconURL from './pirSensor/pir-small.png';

import dhtSensorIconURL from './dhtSensor/dht-banner.png';
import dhtSensorInsetIconURL from './dhtSensor/dht-small.png';

import buzzerActuatorIconURL from './buzzerActuator/buzzer-banner.png';
import buzzerActuatorInsetIconURL from './buzzerActuator/buzzer-small.png';

import worldWeatherIconURL from './worldWeather/world-weather-banner.png';
import worldWeatherInsetIconURL from './worldWeather/world-weather-small.png';

import faceDetectionIconURL from './faceDetection/face-detection-banner.png';
import faceDetectionInsetIconURL from './faceDetection/face-detection-small.png';

import objectDetectionIconURL from './objectDetection/object-detection-banner.png';
import objectDetectionInsetIconURL from './objectDetection/object-detection-small.png';

import speechRecognitionIconURL from './speech2text/speech-recognition-banner.png';
import speechRecognitionInsetIconURL from './speech2text/speech-recognition-small.png';

import humanBodyDetectionIconURL from './humanBodyDetection/human-body-detection-banner.png';
import humanBodyDetectionInsetIconURL from './humanBodyDetection/human-body-detection-small.png';

import geminiIconURL from './geminiAI/geminiai_banner.png';
import geminiInsetIconURL from './geminiAI/gemini_small.png';

export default [
    {
        name: (
            <FormattedMessage
                defaultMessage="Gemini AI"
                description="Name for the Gemini LLM extension"
                id="gui.extension.geminiLLM.name"
            />
        ),
        extensionId: 'geminiLLM',
        collaborator: 'Google Gemini',
        iconURL: geminiIconURL,
        insetIconURL: geminiInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Connect to Google's Gemini LLM to generate text from prompts."
                description="Description for the Gemini LLM extension"
                id="gui.extension.geminiLLM.description"
            />
        ),
        featured: true,
        internetConnectionRequired: true,
        tags: ['ai-ml']
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Natural Language Processing"
                description="Name for the 'Natural Language Processing' extension"
                id="gui.extension.nlp.name"
            />
        ),
        extensionId: 'naturalLanguageProcessing',
        iconURL: nlpIconURL,
        insetIconURL: nlpInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Train and use text classifiers, entity extraction, and sentiment analysis."
                description="Description for the 'NLP' extension"
                id="gui.extension.nlp.description"
            />
        ),
        featured: true,
        tags: ['ai-ml']
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Machine Learning Models"
                description="Name for the custom Machine Learning models extension"
                id="gui.extension.mlClassifier.name"
            />
        ),
        extensionId: 'mlClassifier',
        iconURL: objectDetectionIconURL,
        insetIconURL: objectDetectionInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Use your custom trained models from the ML Environment."
                description="Description for the custom ML models extension"
                id="gui.extension.mlClassifier.description"
            />
        ),
        featured: true,
        internetConnectionRequired: false,
        tags: ['ai-ml']
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Object Detection"
                description="Name for the 'Object Detection' extension"
                id="gui.extension.objectDetection.name"
            />
        ),
        extensionId: 'objectDetection',
        iconURL: objectDetectionIconURL,
        insetIconURL: objectDetectionInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Detect and identify 80 types of objects using the camera."
                description="Description for the 'Object Detection' extension"
                id="gui.extension.objectDetection.description"
            />
        ),
        featured: true,
        internetConnectionRequired: true,
        tags: ['ai-ml']
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Face Detection"
                description="Name for the 'Face Detection' extension"
                id="gui.extension.faceDetection.name"
            />
        ),
        extensionId: 'faceDetection',
        iconURL: faceDetectionIconURL,
        insetIconURL: faceDetectionInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Detect faces, expressions, age, gender, and recognize saved faces."
                description="Description for the 'Face Detection' extension"
                id="gui.extension.faceDetection.description"
            />
        ),
        featured: true,
        internetConnectionRequired: true,
        tags: ['ai-ml']
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Human Body Detection"
                description="Name for the 'Human Body Detection' extension"
                id="gui.extension.humanBodyDetection.name"
            />
        ),
        extensionId: 'humanBodyDetection',
        iconURL: humanBodyDetectionIconURL,
        insetIconURL: humanBodyDetectionInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Detect human poses with 17 body keypoints and hand gestures with 21 hand keypoints."
                description="Description for the 'Human Body Detection' extension"
                id="gui.extension.humanBodyDetection.description"
            />
        ),
        featured: true,
        internetConnectionRequired: true,
        tags: ['ai-ml']
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Speech Recognition"
                description="Name for the 'Speech Recognition' extension"
                id="gui.extension.speechRecognition.name"
            />
        ),
        extensionId: 'speechRecognition',
        iconURL: speechRecognitionIconURL,
        insetIconURL: speechRecognitionInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Convert speech to text in real-time"
                description="Description for the 'Speech Recognition' extension"
                id="gui.extension.speechRecognition.description"
            />
        ),
        featured: true,
        internetConnectionRequired: true,
        tags: ['ai-ml']
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Text to Speech"
                description="Name for the Text to Speech extension"
                id="gui.extension.text2speech.name"
            />
        ),
        extensionId: 'text2speech',
        collaborator: 'Amazon Web Services',
        iconURL: text2speechIconURL,
        insetIconURL: text2speechInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Make your projects talk."
                description="Description for the Text to speech extension"
                id="gui.extension.text2speech.description"
            />
        ),
        featured: true,
        internetConnectionRequired: true,
        tags: ['ai-ml']
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="TTS 2.0"
                description="Name for the Gemini-powered Text to Speech extension"
                id="gui.extension.tts2.name"
            />
        ),
        extensionId: 'tts2',
        collaborator: 'Google Gemini',
        iconURL: text2speechIconURL,
        insetIconURL: text2speechInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Speak in Indian languages for learning."
                description="Description for the Gemini-powered Text to Speech extension"
                id="gui.extension.tts2.description"
            />
        ),
        featured: true,
        internetConnectionRequired: true,
        tags: ['ai-ml']
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Speech Recognition 2.0"
                description="Name for the 'Speech Recognition 2.0' extension"
                id="gui.extension.stt2.name"
            />
        ),
        extensionId: 'stt2',
        collaborator: 'Google Gemini',
        iconURL: speechRecognitionIconURL,
        insetIconURL: speechRecognitionInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="High-accuracy speech to text using Gemini models"
                description="Description for the 'Speech Recognition 2.0' extension"
                id="gui.extension.stt2.description"
            />
        ),
        featured: true,
        internetConnectionRequired: true,
        tags: ['ai-ml']
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Translate"
                description="Name for the Translate extension"
                id="gui.extension.translate.name"
            />
        ),
        extensionId: 'translate',
        collaborator: 'Google',
        iconURL: translateIconURL,
        insetIconURL: translateInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Translate text into many languages."
                description="Description for the Translate extension"
                id="gui.extension.translate.description"
            />
        ),
        featured: true,
        internetConnectionRequired: true,
        tags: ['ai-ml']
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="World Weather"
                description="Name for the 'World Weather' extension"
                id="gui.extension.worldWeather.name"
            />
        ),
        extensionId: 'worldWeather',
        collaborator: 'OpenWeatherMap',
        iconURL: worldWeatherIconURL,
        insetIconURL: worldWeatherInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Get real-time weather, air pollution, and location data."
                description="Description for the 'World Weather' extension"
                id="gui.extension.worldWeather.description"
            />
        ),
        featured: true,
        internetConnectionRequired: true,
        tags: ['iot']
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Generic Hardware"
                description="Name for the Generic Device extension"
                id="gui.extension.genericDevice.name"
            />
        ),
        extensionId: 'genericDevice',
        iconURL: genericDeviceIconURL,
        insetIconURL: genericDeviceInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Connect any custom hardware device to your pins."
                description="Description for the Generic Device extension"
                id="gui.extension.genericDevice.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: false,
        internetConnectionRequired: false,
        tags: ['hardware']
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="LED Actuator"
                description="Name for the 'LED Actuator' extension"
                id="gui.extension.ledActuator.name"
            />
        ),
        extensionId: 'ledActuator',
        iconURL: ledActuatorIconURL,
        insetIconURL: ledActuatorInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Turn LEDs on, off, or set to a specific brightness."
                description="Description for the 'LED Actuator' extension"
                id="gui.extension.ledActuator.description"
            />
        ),
        featured: true,
        tags: ['hardware', 'iot']
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Buzzer Actuator"
                description="Name for the 'Buzzer Actuator' extension"
                id="gui.extension.buzzerActuator.name"
            />
        ),
        extensionId: 'buzzerActuator',
        iconURL: buzzerActuatorIconURL,
        insetIconURL: buzzerActuatorInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Play distinct tones and frequencies."
                description="Description for the 'Buzzer Actuator' extension"
                id="gui.extension.buzzerActuator.description"
            />
        ),
        featured: true,
        tags: ['hardware', 'iot']
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="DC Motor"
                description="Name for the 'DC Motor' extension"
                id="gui.extension.dcMotor.name"
            />
        ),
        extensionId: 'dcMotor',
        iconURL: dcMotorIconURL,
        insetIconURL: dcMotorInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Control a DC motor using an L293D or similar driver."
                description="Description for the 'DC Motor' extension"
                id="gui.extension.dcMotor.description"
            />
        ),
        featured: true,
        tags: ['hardware']
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="OLED Display"
                description="Name for the 'OLED Display' extension"
                id="gui.extension.oledDisplay.name"
            />
        ),
        extensionId: 'oledDisplay',
        iconURL: oledDisplayIconURL,
        insetIconURL: oledDisplayInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Draw text and shapes on an OLED display."
                description="Description for the 'OLED Display' extension"
                id="gui.extension.oledDisplay.description"
            />
        ),
        featured: true,
        tags: ['hardware']
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Servo Motor"
                description="Name for the 'Servo Motor' extension"
                id="gui.extension.servoMotor.name"
            />
        ),
        extensionId: 'servoMotor',
        iconURL: servoMotorIconURL,
        insetIconURL: servoMotorInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Control the precise angle of a servo motor."
                description="Description for the 'Servo Motor' extension"
                id="gui.extension.servoMotor.description"
            />
        ),
        featured: true,
        tags: ['hardware']
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="IR Sensor"
                description="Name for the 'IR Sensor' extension"
                id="gui.extension.irSensor.name"
            />
        ),
        extensionId: 'irSensor',
        iconURL: irSensorIconURL,
        insetIconURL: irSensorInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Detect objects with an infrared sensor."
                description="Description for the 'IR Sensor' extension"
                id="gui.extension.irSensor.description"
            />
        ),
        featured: true,
        tags: ['hardware']
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="PIR Motion Sensor"
                description="Name for the 'PIR Motion Sensor' extension"
                id="gui.extension.pirSensor.name"
            />
        ),
        extensionId: 'pirSensor',
        iconURL: pirSensorIconURL,
        insetIconURL: pirSensorInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Detect human or animal motion."
                description="Description for the 'PIR Motion Sensor' extension"
                id="gui.extension.pirSensor.description"
            />
        ),
        featured: true,
        tags: ['hardware', 'iot']
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Ultrasonic Sensor"
                description="Name for the 'Ultrasonic Sensor' extension"
                id="gui.extension.ultrasonicSensor.name"
            />
        ),
        extensionId: 'ultrasonicSensor',
        iconURL: ultrasonicSensorIconURL,
        insetIconURL: ultrasonicSensorInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Measure distance with an ultrasonic sensor."
                description="Description for the 'Ultrasonic Sensor' extension"
                id="gui.extension.ultrasonicSensor.description"
            />
        ),
        featured: true,
        tags: ['hardware']
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="DHT Temp & Humidity"
                description="Name for the 'DHT Sensor' extension"
                id="gui.extension.dhtSensor.name"
            />
        ),
        extensionId: 'dhtSensor',
        iconURL: dhtSensorIconURL,
        insetIconURL: dhtSensorInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Read temperature and humidity."
                description="Description for the 'DHT Sensor' extension"
                id="gui.extension.dhtSensor.description"
            />
        ),
        featured: true,
        tags: ['hardware', 'iot']
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Heart Rate Sensor"
                description="Name for the MAX30105 extension"
                id="gui.extension.max30105.name"
            />
        ),
        extensionId: 'max30105',
        iconURL: max30105IconURL,
        insetIconURL: max30105InsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Read heart rate and pulse oximetry with MAX30105."
                description="Description for the MAX30105 extension"
                id="gui.extension.max30105.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: false,
        internetConnectionRequired: false,
        tags: ['hardware']
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Music"
                description="Name for the 'Music' extension"
                id="gui.extension.music.name"
            />
        ),
        extensionId: 'music',
        iconURL: musicIconURL,
        insetIconURL: musicInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Play instruments and drums."
                description="Description for the 'Music' extension"
                id="gui.extension.music.description"
            />
        ),
        featured: true
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Pen"
                description="Name for the 'Pen' extension"
                id="gui.extension.pen.name"
            />
        ),
        extensionId: 'pen',
        iconURL: penIconURL,
        insetIconURL: penInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Draw with your sprites."
                description="Description for the 'Pen' extension"
                id="gui.extension.pen.description"
            />
        ),
        featured: true
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Video Sensing"
                description="Name for the 'Video Sensing' extension"
                id="gui.extension.videosensing.name"
            />
        ),
        extensionId: 'videoSensing',
        iconURL: videoSensingIconURL,
        insetIconURL: videoSensingInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Sense motion with the camera."
                description="Description for the 'Video Sensing' extension"
                id="gui.extension.videosensing.description"
            />
        ),
        featured: true
    },
    {
        name: 'Makey Makey',
        extensionId: 'makeymakey',
        collaborator: 'JoyLabz',
        iconURL: makeymakeyIconURL,
        insetIconURL: makeymakeyInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Make anything into a key."
                description="Description for the 'Makey Makey' extension"
                id="gui.extension.makeymakey.description"
            />
        ),
        featured: true,
        tags: ['hardware']
    },
    {
        name: 'micro:bit',
        extensionId: 'microbit',
        collaborator: 'micro:bit',
        iconURL: microbitIconURL,
        insetIconURL: microbitInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Connect your projects with the world."
                description="Description for the 'micro:bit' extension"
                id="gui.extension.microbit.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        internetConnectionRequired: true,
        launchPeripheralConnectionFlow: true,
        useAutoScan: false,
        connectionIconURL: microbitConnectionIconURL,
        connectionSmallIconURL: microbitConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their micro:bit."
                id="gui.extension.microbit.connectingMessage"
            />
        ),
        helpLink: 'https://scratch.mit.edu/microbit',
        tags: ['hardware']
    },
    {
        name: 'LEGO MINDSTORMS EV3',
        extensionId: 'ev3',
        collaborator: 'LEGO',
        iconURL: ev3IconURL,
        insetIconURL: ev3InsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Build interactive robots and more."
                description="Description for the 'LEGO MINDSTORMS EV3' extension"
                id="gui.extension.ev3.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        internetConnectionRequired: true,
        launchPeripheralConnectionFlow: true,
        useAutoScan: false,
        connectionIconURL: ev3ConnectionIconURL,
        connectionSmallIconURL: ev3ConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting. Make sure the pin on your EV3 is set to 1234."
                description="Message to help people connect to their EV3. Must note the PIN should be 1234."
                id="gui.extension.ev3.connectingMessage"
            />
        ),
        helpLink: 'https://scratch.mit.edu/ev3',
        tags: ['robots']
    },
    {
        name: 'LEGO BOOST',
        extensionId: 'boost',
        collaborator: 'LEGO',
        iconURL: boostIconURL,
        insetIconURL: boostInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Bring robotic creations to life."
                description="Description for the 'LEGO BOOST' extension"
                id="gui.extension.boost.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        internetConnectionRequired: true,
        launchPeripheralConnectionFlow: true,
        useAutoScan: true,
        connectionIconURL: boostConnectionIconURL,
        connectionSmallIconURL: boostConnectionSmallIconURL,
        connectionTipIconURL: boostConnectionTipIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their BOOST."
                id="gui.extension.boost.connectingMessage"
            />
        ),
        helpLink: 'https://scratch.mit.edu/boost',
        tags: ['robots']
    },
    {
        name: 'LEGO Education WeDo 2.0',
        extensionId: 'wedo2',
        collaborator: 'LEGO',
        iconURL: wedo2IconURL,
        insetIconURL: wedo2InsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Build with motors and sensors."
                description="Description for the 'LEGO WeDo 2.0' extension"
                id="gui.extension.wedo2.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        internetConnectionRequired: true,
        launchPeripheralConnectionFlow: true,
        useAutoScan: true,
        connectionIconURL: wedo2ConnectionIconURL,
        connectionSmallIconURL: wedo2ConnectionSmallIconURL,
        connectionTipIconURL: wedo2ConnectionTipIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their WeDo."
                id="gui.extension.wedo2.connectingMessage"
            />
        ),
        helpLink: 'https://scratch.mit.edu/wedo',
        tags: ['robots']
    },
    {
        name: 'Go Direct Force & Acceleration',
        extensionId: 'gdxfor',
        collaborator: 'Vernier',
        iconURL: gdxforIconURL,
        insetIconURL: gdxforInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Sense push, pull, motion, and spin."
                description="Description for the Vernier Go Direct Force and Acceleration sensor extension"
                id="gui.extension.gdxfor.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        internetConnectionRequired: true,
        launchPeripheralConnectionFlow: true,
        useAutoScan: false,
        connectionIconURL: gdxforConnectionIconURL,
        connectionSmallIconURL: gdxforConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their force and acceleration sensor."
                id="gui.extension.gdxfor.connectingMessage"
            />
        ),
        helpLink: 'https://scratch.mit.edu/vernier',
        tags: ['hardware']
    }
];
